import React, { useEffect } from "react"
import types from "prop-types"
import { TextInput } from "shared/inputs"
import { IconButton } from "shared/buttons"

const SearchInput = ({
  isSelectorHidden, search, setSearch, onSearchInputEnter, placeholder, ref = undefined,
}) => {
  useEffect(() => {
    if (!isSelectorHidden) {
      ref?.current?.focus()
    }
  }, [isSelectorHidden, ref])

  return (
    <div className="my-1 border-b border-lightgray-3 flex-center">
      <TextInput
        ref={ref}
        value={search}
        onChange={(value) => setSearch({ target: { value } })}
        onKeyDown={onSearchInputEnter}
        placeholder={placeholder}
      />
      <IconButton icon="fas fa-search" />
    </div>
  )
}

SearchInput.displayName = "SearchInput"

SearchInput.propTypes = {
  isSelectorHidden: types.bool.isRequired,
  onSearchInputEnter: types.func.isRequired,
  search: types.string.isRequired,
  setSearch: types.func.isRequired,
  placeholder: types.string.isRequired,
  ref: types.oneOfType([types.func, types.object]),
}

export default SearchInput
